<div class="step-panel">

  <div style="display:flex;align-items:center;gap:10px;margin-bottom:18px;flex-wrap:wrap">
    <div class="pg-title" style="margin-bottom:0">Application create</div>
    <span class="badge b-b">Step 1 / 13</span>
  </div>

  <!-- FORM -->
  <div class="card">
    <div class="card-title"><div class="ct-bar"></div>Institute + receivable</div>

    <div class="fg c2">

      <div class="fl">
        <label>Institute</label>
        <input class="inp-af inp-ro" type="text" [value]="instituteName" readonly>
      </div>

      <div class="fl">
        <label>Institute type</label>
        <input class="inp-af inp-ro" type="text" [value]="instituteType" readonly>
      </div>

      <div class="fl">
        <label>Beneficiary ID <span class="req">*</span></label>
        <input type="text" [(ngModel)]="beneficiaryId" readonly class="inp-ro">
      </div>

      <div class="fl">
        <label>Borrower name</label>
        <input type="text" [(ngModel)]="name" readonly class="inp-ro">
      </div>

      <div class="fl">
        <label>Fee amount</label>
        <input type="number" [(ngModel)]="feeAmount" readonly class="inp-ro">
      </div>

      <div class="fl">
        <label>Loan amount <span class="req">*</span></label>
        <input type="number" [(ngModel)]="loanAmount" (ngModelChange)="onAmountOrTenureChange()">
      </div>

      <div class="fl">
        <label>Tenure (months) <span class="req">*</span></label>
        <input type="number" [(ngModel)]="tenureMonths" min="1" max="60" (ngModelChange)="onAmountOrTenureChange()">
      </div>

      <div class="fl" *ngIf="emiPreview > 0">
        <label>EMI preview <span class="ftag ft-sys">CALCULATED</span></label>
        <div class="emi-band" style="max-width:280px">
          <div class="emi-lbl">Estimated monthly EMI</div>
          <div class="emi-val">₹{{ emiPreview | number: "1.0-2" }}</div>
        </div>
      </div>

    </div>

  </div>

  <div class="nav-bar">
    <button class="btn btn-sec" disabled>← Previous step</button>
    <button class="btn btn-pri btn-lg" (click)="saveAndContinue()" [disabled]="isSaving">
      <span *ngIf="!isSaving">Save & Continue →</span>
      <span *ngIf="isSaving">Saving...</span>
    </button>
  </div>

</div>